export default {
  st_config: {
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL
  },
  uat_token: process.env.VUE_APP_UAT_TOKEN,
  google_sso_client_id: process.env.VUE_APP_GOOGLE_SSO_CLIENT_ID,
  editor_url: process.env.VUE_APP_STC_BASE_URL,
  elabel_editor_url: process.env.VUE_APP_ELABEL_EDITOR_BASE_URL,
  default_stc_url: process.env.VUE_APP_DEFAULT_STC_URL,
  default_elabel_url: process.env.VUE_APP_ELABEL_URL,
  remy_elabel_url: process.env.VUE_APP_REMY_ELABEL_URL,
  dpp_editor_url: process.env.VUE_APP_DPP_EDITOR_URL,
  dpp_landing_page_url: process.env.VUE_APP_DPP_LANDING_PAGE_URL,
  qr_service_url: process.env.VUE_APP_QR_SERVICE_URL,
  amplitude_key: process.env.VUE_APP_AMPLITUDE_KEY,
  sentry_key: process.env.VUE_APP_SENTRY_KEY,
  zendesk_sso: process.env.VUE_APP_ZENDESK_SSO === 'true',
  iccube_url: process.env.VUE_APP_ICCUBE_URL,
  elabel_template_url: process.env.VUE_APP_ELABEL_TEMPLATE_URL,
  paddle_vendor_id: process.env.VUE_APP_PADDLE_SDK_VENDOR_ID,
  paddle_client_token: process.env.VUE_APP_PADDLE_CLIENT_TOKEN,
  paddle_plans: {
    'st-pro': {
      month: process.env.VUE_APP_PADDLE_PLAN_ST_PRO,
      year: process.env.VUE_APP_PADDLE_PLAN_ST_PRO_YEARLY,
      day: process.env.VUE_APP_PADDLE_PLAN_ST_PRO_DAILY
    }
  },
  hubspot: {
    region: 'na1',
    portal_id: '4646774',
    contact_form_id: '17a6972f-45c9-430a-a908-932a98917632'
  }
}
